import type { IconProps } from '@/shared/ui/icons/types';

export const WarehouseIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3 21V8.5a1 1 0 0 1 .65-.94l8-3a1 1 0 0 1 .7 0l8 3a1 1 0 0 1 .65.94V21" />
    <path d="M3 21h18" />
    <path d="M7 21v-7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7" />
    <path d="M7 16.5h10" />
  </svg>
);
